
import './App.css';
import './index.css'
import Hero from './component/Hero';

function App() {
  return (
    <div className="App">
    <Hero/>
    </div>
  );
}

export default App;
